export const RATES_REQUEST_START: string = 'rates/REQUEST_START';
export const RATES_REQUEST_FAIL: string = 'rates/REQUEST_FAIL';
export const RATES_REQUEST_SUCCESS: string = 'rates/REQUEST_SUCCESS';
